<mat-form-field
  [appearance]="appearance || 'legacy'"
  [floatLabel]="prefixText || !label || !isEmpty(value) ? 'always' : 'auto'"
  class="w-full"
>
  <mat-label>{{ label }}</mat-label>
  <fb-anex
    *ngIf="prefix && prefix.type !== 'text'"
    matPrefix
    [config]="prefix"
    [control]="control"
    [templates]="templates"
    position="start"
  ></fb-anex>
  <input
    class="number-input"
    type="text"
    matInput
    fbDisableAutocomplete
    mask="{{ useCommaSeparator | numberFieldMask : digitsCount }}"
    [thousandSeparator]="useCommaSeparator ? ',' : undefined"
    [prefix]="prefixText"
    [validation]="true"
    [allowNegativeNumbers]="min === undefined || min < 0"
    [formControl]="numberControl"
    [placeholder]="placeholder"
    [required]="required"
    [fbDisableControl]="disable || readonly || numberControl.disabled"
    [minlength]="minlength"
    [maxlength]="maxlength"
    [readonly]="readonly"
    (focusout)="onTouched()"
  />
  <ng-container *ngIf="(loading.active$ | async) === false; else showLoader">
    <fb-anex
      *ngIf="suffix"
      [style.margin-right.px]="0"
      matSuffix
      [config]="suffix"
      [control]="ngControl.control"
      [templates]="templates"
      position="end"
    ></fb-anex>
  </ng-container>
  <ng-template #showLoader>
    <fb-loader class="position-relative loader" [size]="20" [message]="undefined" matSuffix></fb-loader>
  </ng-template>
</mat-form-field>
